module.exports = __webpack_public_path__ + "static/media/no-image.e38d2f69.jpg";